import React, { useEffect, useMemo, useRef, useState } from "react";
import { COMMON_WEB_PATH } from "../../../constant";
import { Box, Image, useBreakpointValue } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { toggleBGM } from "../../../redux/action/action";
import useCheckLogin from "../../../hook/useCheckLogin";
import VolumeSlider from "../../VolumnSlider/VolumeSlider";

const MusicToggleButton = () => {
  const isBGMEnabled = useSelector((state) => state.isBGMEnabled);
  const { enabled, musicVolume = 0.2 } = isBGMEnabled || {};
  const dispatch = useDispatch();

  const { isMachineUser } = useCheckLogin();

  const iconSize = useMemo(() => {
    return {
      base: "40px",
      md: "50px",
      xl: isMachineUser ? "55px" : "55px",
    };
  }, [isMachineUser]);

  const iconHeightSize = useMemo(() => {
    return {
      base: "40px",
      md: "50px",
      xl: isMachineUser ? "55px" : "55px",
    };
  }, [isMachineUser]);

  // 控制音量滑塊的顯示與隱藏
  const [isVolumeSliderOpen, setIsVolumeSliderOpen] = useState(false);
  const buttonRef = useRef(null);

  // useBreakpointValue 來決定是否顯示音量滑塊 寬度小於 md 不顯示
  const showVolumeSlider = useBreakpointValue({ base: false, md: true });

  // 根據音量和啟用狀態決定顯示哪個圖標
  // 當音量為 0 或未啟用時，顯示靜音圖標
  const shouldShowMuteIcon = musicVolume === 0 || !enabled;

  // 存上一次非零的音量值 用來切換靜音/取消靜音 後恢復音量
  const [lastNonZeroVolume, setLastNonZeroVolume] = useState(
    musicVolume > 0 ? musicVolume : 0.2
  );

  // 處理音量變化
  useEffect(() => {
    if (musicVolume > 0) {
      setLastNonZeroVolume(musicVolume);
    }
  }, [musicVolume]);

  // 點擊按鈕的處理邏輯
  const handleButtonClick = (e) => {
    e.stopPropagation(); // 阻止事件冒泡

    if (showVolumeSlider) {
      // md及以上：顯示/隱藏音量滑塊
      setIsVolumeSliderOpen(!isVolumeSliderOpen);
    } else {
      // 小於md：切換音樂的開/關
      if (enabled) {
        // 如果當前已啟用音樂，點擊後設為靜音
        dispatch(
          toggleBGM({
            ...isBGMEnabled,
            enabled: false,
          })
        );
      } else {
        // 如果當前已靜音，點擊後恢復音量
        dispatch(
          toggleBGM({
            ...isBGMEnabled,
            enabled: true,
            musicVolume: lastNonZeroVolume,
          })
        );
      }
    }
  };

  // 關閉音量滑塊
  const closeVolumeSlider = () => {
    setIsVolumeSliderOpen(false);
  };

  // 在點擊頁面其他部分時關閉音量滑塊
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (buttonRef.current && !buttonRef.current.contains(event.target)) {
        setIsVolumeSliderOpen(false);
      }
    };

    if (isVolumeSliderOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isVolumeSliderOpen]);

  return (
    <Box
      onClick={handleButtonClick} // 點擊整個按鈕區域顯示/隱藏音量滑塊或切換音樂開/關
      ref={buttonRef}
      className="music-toggle-button"
      position="relative"
      cursor="pointer"
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Image
        src={
          enabled
            ? `${COMMON_WEB_PATH}/theOne/header/sound_on_icon.png`
            : `${COMMON_WEB_PATH}/theOne/header/sound_off_icon.png`
        }
        height={iconHeightSize}
        //minW="50px"
        minW={iconSize}
        maxW={iconSize}
      />
      {/* 只在 md 及以上顯示音量滑塊 */}
      {showVolumeSlider && (
        <VolumeSlider isOpen={isVolumeSliderOpen} onClose={closeVolumeSlider} />
      )}
    </Box>
  );
};

export default MusicToggleButton;
